import { UserRole } from "@jugl-web/rest-api";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const ContactsPage = lazy(() => import("./ContactsPage"));

export type ContactsPagesNavigationParams = {
  contactsContacts: PageNavParams;
};

export const contactsPagesNavigationConfig: ModulePagesConfig<ContactsPagesNavigationParams> =
  {
    contactsContacts: {
      element: <ContactsPage />,
      path: "contacts",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
    },
  };
